import {
  Dialog,
  DialogActions,
  makeStyles,
  Typography,
  IconButton,
} from '@material-ui/core'
import { Close, Power, PowerOff } from '@material-ui/icons'
import React, { useState } from 'react'
import { useTranslate } from 'react-admin'
import { ResourceName } from '../../../core/ResourceName'
import Button from '../../common/customized-mui-components/Button'
import DraggableComponent from '../../common/DraggableComponent'
import { ConfirmDialog } from '../../common/ConfirmDialog'
import { AuditCommentActionDialog } from '../../common/AuditCommentDialog'

const useStyles = makeStyles({
  bulkProgressTitle: {
    paddingLeft: '10px',
    width: '100%',
  },
  bulkProgressCloseButton: {
    margin: 0,
  },
  bulkStateActions: {
    height: '16px',
    background: 'rgba(0,0,0,0.2)',
    minWidth: '300px',
    userSelect: 'none',
  },
  actionsButton: {
    margin: '2%',
    width: '96%',
  },
})

export const BarrierSelectStateDialog = ({
  open,
  close,
  state,
  setState,
  confirm,
  method,
  asRecurringJob,
  OnIcon,
  OffIcon,
  withAuditNote,
}: {
  open: boolean
  close: () => void
  state: boolean
  setState: (value: boolean) => void
  confirm: (
    recurringJobName?: string,
    cronExpression?: string,
    auditNote?: string,
  ) => void
  method: string
  asRecurringJob?: boolean
  OnIcon?: React.ReactElement
  OffIcon?: React.ReactElement
  withAuditNote?: boolean
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false)
  const translate = useTranslate()
  const classes = useStyles()

  const handleClose = () => {
    setState(false)
    setConfirmOpen(false)
    close()
  }

  const handleConfirm = (
    recurringJobName?: string,
    cronExpression?: string,
    auditNote?: string,
  ) => {
    if (asRecurringJob) confirm(recurringJobName, cronExpression, auditNote)
    else confirm(undefined, undefined, auditNote)
    handleClose()
  }

  const handleOpenConfirm = (value: boolean) => {
    setState(value)
    setConfirmOpen(true)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
      PaperComponent={DraggableComponent}
      aria-labelledby="draggable-dialog-title"
      onClick={(e) => e.stopPropagation()}
    >
      {!withAuditNote ? (
        <ConfirmDialog
          open={confirmOpen}
          cancel={() => setConfirmOpen(false)}
          confirm={handleConfirm}
          source={method}
          action={state ? 'set' : 'remove'}
          resource={ResourceName.BARRIERS}
          asRecurringJob={asRecurringJob}
        />
      ) : (
        <AuditCommentActionDialog
          open={confirmOpen}
          handleClose={() => setConfirmOpen(false)}
          mutate={handleConfirm}
          asRecurringJob={asRecurringJob}
        />
      )}
      <DialogActions
        className={classes.bulkStateActions}
        style={{ cursor: 'move' }}
      >
        <Typography
          className={classes.bulkProgressTitle}
          id="draggable-dialog-title"
        >
          {translate(`resources.barriers.dialogs.${method}.title`)}
        </Typography>
        <IconButton
          size="small"
          className={classes.bulkProgressCloseButton}
          onClick={handleClose}
        >
          <Close fontSize="small" />
        </IconButton>
      </DialogActions>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => handleOpenConfirm(false)}
          label={translate('const.turnOff')}
          useSmallVersionBreakpoint={false}
          endIcon={OffIcon ?? <PowerOff />}
          className={classes.actionsButton}
        />
        <Button
          variant="contained"
          onClick={() => handleOpenConfirm(true)}
          label={translate('const.turnOn')}
          useSmallVersionBreakpoint={false}
          endIcon={OnIcon ?? <Power />}
          className={classes.actionsButton}
        />
      </DialogActions>
    </Dialog>
  )
}
